var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgPricinglist = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M12.188 6.311v9.252H2.813v-12a1.5 1.5 0 0 1 1.5-1.5h9.375" }), _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M12.188 7.268V3.563a1.5 1.5 0 1 1 3 0v6h-3M9.375 6.184H6.75a1.314 1.314 0 0 0 0 2.628h1.5a1.314 1.314 0 0 1 0 2.625h-3M7.313 4.5v1.875m0 4.875v1.875" })] }))); };
export default SvgPricinglist;
